<template>
  <div class="scene_bg_select">
    <div class="scene_bg_selectupload">
      <div class="scene_bg_selectupload-main">
        <p>{{ $t('sceneTemplate.selectImg') }}</p>
        <el-radio-group
          v-model="updateType"
          class="scene_bg_selectbgRadio"
          @input="updateTypeChange"
        >
          <!-- 横向 -->
          <el-radio :label="1">
            {{ $t('sceneTemplate.imageTemplate') }}
          </el-radio>
          <!-- 纵向 -->
          <el-radio :label="2">
            {{ $t('sceneTemplate.customUpload') }}
          </el-radio>
        </el-radio-group>
        <div
          class="scene_bg_selectbgSelect"
        >
          <ul
            v-if="updateType === 1"
          >
            <li
              v-for="(item, index) in bglist"
              :key="index"
              @click="() => handlerBgChange(index)"
            >
              <div
                :class="{active: activeBgIndex === index, 'shape-1': shapeType === 1, 'shape-2': shapeType === 2}"
                class="scene_bg_selectbgSelect_border"
              />
              <img :src="item.img">
              <p>{{ item.text }}</p>
            </li>
          </ul>
          <div
            v-if="updateType === 2"
            class="upload_box"
          >
            <el-upload
              class="avatar-uploader"
              accept="image/*"
              action="xxx"
              :auto-upload="false"
              :show-file-list="false"
              :on-change="onImageChange"
            >
              <!-- <img
                v-if="imageUrl && !bglist.includes(imageUrl)"
                :src="imageUrl"
                class="avatar"
              > -->
              <div
                class=""
              >
                <i
                  class="el-icon-plus avatar-uploader-icon"
                />
                <p class="avatar-uploader_text">
                  {{ $t('visual.please') }}{{ $t('visual.uploadImg') }} {{ shapeType === 1 ? `${$t('visual.imgSize')} 1000 x 1000px` : '' }}, {{ $t('sceneTemplate.limit') }}
                </p>
              </div>
            </el-upload>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DrawCanvas, { MODE_TYPE_ENUMS } from '@/components/DrawCanvas/index';
import { loadAsyncImg } from '@/components/DesignCanvas/index';
import { UploadFile } from "@/axios/ICommon.js";
import i18n from '@/i18n/i18n'
import { GetImageSenceList } from "@/axios/IFttt.js";
import DesignCanvas from "@/components/DesignCanvas";

export default {
  components: {},
  inject: [],
  props: {
    shapeType: {
      type: Number,
      default: 1
    },
    isCanSelect: {
      type: Boolean,
      default: true,
    },
    from: {
      type: String,
      default: null,
    }
  },

  data() {
    return {
      imageUrl: '',
      updateType: 1,
      bglist: [],
      activeBgIndex: 0,
    }
  },

  watch: {

  },

  mounted() {
    this.setBgList();   
  },

  methods: {
    async setBgList() {
      const res = await GetImageSenceList('matrix_scene_recommend_image');

      this.bglist = (res.Result || []).map(item => ({
        text: (item.Name || '').replace(new RegExp(this.$t('scene.WebImageScene') + '\\s?-'), ''),
        img: item.FileUrl
      }));
      // this.bglist = this.shapeType === 1 ? [ ...bgListConfig1 ] : [ ...bgListConfig2 ];

      if (this.from === 'edit' || this.from === 'copy') return;

      const bgData = this.bglist[this.activeBgIndex];

      this.$emit('imgUpdate', bgData.img);
    },

    setBg(url) {
      this.imageUrl = url;

      const activeBgIndex = this.bglist.findIndex(item => item.img === url);

      this.activeBgIndex = activeBgIndex;

      if (activeBgIndex === -1) {
        this.updateType = 2;
        // this.$emit('imgUpdate', url);
      }
    },

    updateTypeChange(value) {
      if (this.value === 1) {
        this.imageUrl = '';
      }
    },

    handlerBgChange(index) {
      // if (index === this.activeBgIndex || !this.isCanSelect) return;

      this.activeBgIndex =  index;
      const bgData = this.bglist[index];

      this.$emit('imgUpdate', bgData.img, bgData.text);
    },


    setCurLineLayerIndex(deviceId) {
      if (this.drawCanvasInstance) {
        this.drawCanvasInstance.setCurLineLayerIndex(deviceId);
      }
    },

    async onImageChange(file) {
      const url = URL.createObjectURL(file.raw);
      const img = await loadAsyncImg(url);

      const { width, height } = img;
      
      // if (this.shapeType === 1 && (width !== 1000 || height !== 1000)) {
      //   this.$message.error(
      //     `${this.$t('visual.uploadImg')}${this.$t('sceneCard.size')}1000 x 1000`
      //   );

      //   return;
      // }

      if (file.size > 3 * 1024 * 1024) {
        this.$message.error(`${this.$t('visual.uploadImg')}${this.$t('lastLight.lessthan')}3M`)

        return;
      }

      const formData = new FormData();

      formData.append("file", file.raw);

      UploadFile(formData, (res) => {
        if (res.StatusCode === this.$store.state.rightStatusCode) {
          const { canvasInitData = {}} = this;
          // const modeType = this.modeType || canvasInitData.modeType;
          const cdnUrl = res.Result.RootPath + res.Result.FilePath;
          this.imageUrl = url;
        
          this.activeBgIndex = -1

          this.$emit('imgUpdate', cdnUrl);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.scene_bg_select {
  width: 100%;
  height: 100%;
  background-color: #fff;

  .scene_container {
    // display: flex;
    width: 100%;
    box-sizing: border-box;

    &_info {
      width: 100%;
      padding: 10px 20px;
      background-color: #F4F5F8;
      color: #8C8C8C;
    }
  }
  .scene_bg_selectpreview {
    flex: 1;
  }

  #preview_canvas {
    width: 100%;
    margin-top: 20px;
    // border: 1px solid #eee;
    background: url(../../../../components/DrawCanvas/assets/psBg.png) repeat;
    background-size: 40px 40px;

    &.preview_canvas-shapeType-1 {
      height: 1171px;
    }

    &.preview_canvas-shapeType-2 {
      height: 1236px;
    }
  }

  .scene_bg_selectupload {
    display: flex;
    margin-bottom: 60px;
  }

  .scene_bg_selectupload-article {
    display: flex;
    padding-top: 55px;
    padding-left: 20px;
  }

.scene_bg_selectbgRadio {
  margin-top: 20px;
}

.scene_bg_selectbgSelect {
  margin-top: 20px;
}

.scene_bg_selectbgSelect {
  ul {
    display: flex;
    align-items: center;
    margin-left: 5px;
    flex-wrap: wrap;
  }

  li {
    position: relative;
    width: 105px;
    margin-right: 16px;
    margin-bottom: 10px;
    cursor: pointer;

    .scene_bg_selectbgSelect_border {
      display: none;
      position: absolute;
      width: 95px;
      height: 95px;
      top: -5px;
      left: -5px;
      border: 10px solid #2589FF;
      &.shape-1 {
        border-radius: 50%;
      }
      &.shape-2 {
        border-radius: 0;
      }
      &.active {
        display: block;
      }
    }

    img {
      width: 100%;
    }

    p {
      margin-top: 13px;
      text-align: center;
    }
  }
}

.upload_box {
  display: flex;
  width: 238px;
  height: 238px;
  align-items: center;
  justify-content: center;
  border: 2px dashed #ccc;
  color: #D0D0D0;
  overflow: hidden;

  p {
    margin-top: 10px;
  }
  ::v-deep .el-icon-plus {
    font-size: 80px;
    font-weight: bold;
    
  }

  img {
    max-width: 100%;
  }
}

.avatar-uploader_text {
  width: 180px;
  margin: 0 auto;
}
.scene_bg_selecttip_container {
  width: 350px;
}

.scene_bg_selecttip {
  // margin-top: 30px;
  margin-bottom: 5px;
}

.scene_bg_selecttip-info {
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  align-items: flex-start;
  height: 60px;
  max-width: 534px;

  li {
    display: flex;
    width: 50%;
    max-width: 267px;
    margin-bottom: 16px;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .scene_bg_selecttip-info_icon {
    display: flex;
    min-width: 86px;
    min-height: 86px;
    max-width: 86px;
    max-height: 86px;
    padding: 6px;
    background: #0B3687;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    color: #fff;
    box-sizing: border-box;
    // white-space: nowrap;
    text-align: center;
    .scene-canvas_tool-icon {
      width: 30px;
      height: 30px;
    }
    p {
      width: 100%;
      margin-top: 4px;
      font-size: 12px;
    }
   
  }

  .scene_bg_selecttip-info_text {
    display: flex;
    width: 220px;
    margin-left: 15px;
  }
}

}
</style>

<style lang="scss">
.scene-canvas_tool-icon{
  display: block;
  width: 25px;
  height: 25px;
  margin: 0 auto;
}

.scene-canvas_pencil {
  background: url("~@/assets/img/visual/tool-pencil.png") no-repeat 0 0 / 100%
    100%;
}

.scene-canvas_edit {
  background: url("~@/assets/img/visual/edit.png") no-repeat 0 0 / 100%
    100%;
}

.scene-canvas_delete {
  background: url("~@/assets/img/visual/delete.png") no-repeat 0 0 / 100%
      100%;
}

.scene-canvas_back {
  background: url("~@/assets/img/visual/back.png") no-repeat 0 0 / 100%
      100%;
} 
</style>

